import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Container className="vh-100 d-flex justify-content-center align-items-center">
            <Row>
                <Col className="text-center">
                    <h1 className="display-1 text-danger">404</h1>
                    <h3>ไม่พบหน้าที่คุณต้องการ</h3>
                    <p>URL นี้ไม่ตรงกับหน้าใดในระบบ</p>

                    {/* ✅ เส้นคั่นด้านล่าง */}
                    <div style={{
                        height: '3px',
                        backgroundColor: '#f44336',
                        margin: '1.5rem auto 0 auto',
                        borderRadius: '5px'
                    }} />
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;
